import { Moon, Sun } from 'lucide-react'
import { useTheme } from '@/lib/theme'

/**
 * Compact light/dark toggle for the SONAR header. Reuses the starter's theme
 * helper (persists to localStorage `bm-ds-theme`, toggles `.dark` on <html>).
 * Icon visibility is driven purely by the `.dark` class so SSR is deterministic
 * (no hydration mismatch); the resolved theme is read from the DOM on click.
 */
export function SonarThemeToggle() {
  const [, setTheme] = useTheme()

  return (
    <button
      type="button"
      aria-label="Toggle light or dark theme"
      onClick={() => {
        const isDark = document.documentElement.classList.contains('dark')
        setTheme(isDark ? 'light' : 'dark')
      }}
      className="inline-flex h-8 w-8 items-center justify-center rounded-full text-stone-500 transition-colors hover:bg-stone-100 hover:text-stone-900 dark:text-stone-400 dark:hover:bg-stone-800 dark:hover:text-stone-100"
    >
      <Sun className="hidden h-4 w-4 dark:block" />
      <Moon className="block h-4 w-4 dark:hidden" />
    </button>
  )
}

export default SonarThemeToggle
